module.exports = __webpack_public_path__ + "static/media/group.152fb4ae.svg";